// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.turing-ui-v2-editable-list-item {
  display: flex;
}

.turing-ui-v2-editable-list-item-content {
  flex: 1;
}

.turing-ui-v2-editable-list-item-actions {
  display: grid;
  grid-gap: 10px;
  grid-auto-flow: column;
  zoom: 0.7;
  margin-left: 10px;
  align-items: flex-start;
}

.turing-ui-v2-editable-list-btn-add{
    margin-top: 20px;
}

.ant-select{
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/editableList/EditableList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".turing-ui-v2-editable-list-item {\n  display: flex;\n}\n\n.turing-ui-v2-editable-list-item-content {\n  flex: 1;\n}\n\n.turing-ui-v2-editable-list-item-actions {\n  display: grid;\n  grid-gap: 10px;\n  grid-auto-flow: column;\n  zoom: 0.7;\n  margin-left: 10px;\n  align-items: flex-start;\n}\n\n.turing-ui-v2-editable-list-btn-add{\n    margin-top: 20px;\n}\n\n.ant-select{\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
